import React from 'react';

const UserOffIcon = class extends React.Component {
	render() {
		return (
			<svg fill="currentColor" stroke="none" xmlns="http://www.w3.org/2000/svg" viewBox="0 0 32 32" style={this.props.style||{}}>
				<path d="M9.36481,13.37427A1.2749,1.2749,0,0,1,10,11.62988V9c0-3,2-5,5.5-5a6.79133,6.79133,0,0,1,2.64575.50122,7.94842,7.94842,0,0,0,3.59918,8.26123,1.71227,1.71227,0,0,1-.10974.61182l-.28.75146a2.99115,2.99115,0,0,1-1.31073,1.462l-.66583,3.05163A2.99992,2.99992,0,0,1,16.44763,21H14.55237a2.99992,2.99992,0,0,1-2.931-2.3606l-.66583-3.05163a2.99143,2.99143,0,0,1-1.31073-1.462Zm16.704,9.4978-5.13623-2.70532A5.02325,5.02325,0,0,1,16.44727,23H14.55273a5.02388,5.02388,0,0,1-4.48559-2.833l-5.136,2.70508A1.57792,1.57792,0,0,0,4,24.23669V27a1,1,0,0,0,1,1H26a1,1,0,0,0,1-1V24.23669A1.57792,1.57792,0,0,0,26.06885,22.87207ZM32,6a6,6,0,1,1-6-6A6,6,0,0,1,32,6ZM22.56683,8.019,28.0191,2.56689A3.95509,3.95509,0,0,0,26,2a4.00454,4.00454,0,0,0-4,4A3.95448,3.95448,0,0,0,22.56683,8.019ZM30,6a3.95448,3.95448,0,0,0-.56683-2.019L23.9809,9.43311A3.95509,3.95509,0,0,0,26,10,4.00454,4.00454,0,0,0,30,6Z"/>
			</svg>
		);
	}
}

export default UserOffIcon;
